module.exports = __webpack_public_path__ + "static/media/Orange_Button@2x.8e32c0fa.png";